<template><tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :helper_text="helper_text" :fabricator="fabricator">

</tile-question-layout></template>

<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalProfile from "../DesignerQuestionTechnicalProfile.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalProfile
        ],
        props: {
            title: {
                default(){
                    return 'Select A Profile';
                }
            },
            helper_text: {
                default() {
                    return '';
                }
            },
            doorRange: {
              required: true,
              default() {
                return 0;
              }
            },
            frameColourInternal: {
              required: false,
              default() {
                return 1;
              }
            },
            frameColourExternal: {
              required: false,
              default() {
                return 1;
              }
            },
            frameMaterial: {
                required: true,
            },
            securedByDesign: {
              required: false,
              default() {
                return 0;
              }
            },
            hardwareHandle: {
              required: false,
              default() {
                return 0;
              }
            },
            hardwareEscutcheon: {
              required: false,
              default() {
                return 0;
              }
            },
            slab_only: {
              required: false,
              default() {
                return false;
              }
            },
        },
        computed: {
            frame_colour_internal() {
              if(this.slab_only) {
                return 82;
              }

              return 1;
            },
            frame_colour_external() {
              if(this.slab_only) {
                return 82;
              }

              return 1;
            },
            thumbURL(){
                return '/thumb/profile/';
            },
            passed_filter(){
                return this.variable_ready(this.frame_colour_external, this.frame_colour_internal, this.frameMaterial, this.securedByDesign, this.hardwareHandle, this.hardwareEscutcheon, this.doorRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-profile?secured_by_design=' + this.securedByDesign + '&frame_colour_external=' + this.frame_colour_external + '&frame_colour_internal=' + this.frame_colour_internal + '&frame_material=' + this.frameMaterial + '&hardware_handle=' + this.hardwareHandle + '&hardware_escutcheon=' + this.hardwareEscutcheon + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.frame_colour_external + '_' + this.frame_colour_internal + '_' + this.frameMaterial + '_' + this.doorRange;
            },
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
